module.exports = __webpack_public_path__ + "img/choose_music_code.353c5dbc.png";